export interface ParsedPlaylistUrl {
  platform: 'spotify' | 'apple' | 'tidal' | 'youtube';
  playlistId: string;
  originalUrl: string;
}

export function parsePlaylistShareUrl(url: string): ParsedPlaylistUrl | null {
  const cleanUrl = url.trim();
  if (!cleanUrl) return null;

  // 1. Spotify
  // Matches https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M or spotify:playlist:37i9dQZF1DXcBWIGoYBM5M
  const spotifyMatch = cleanUrl.match(/(?:open\.spotify\.com\/playlist\/|spotify:playlist:)([a-zA-Z0-9]+)/);
  if (spotifyMatch) {
    return {
      platform: 'spotify',
      playlistId: spotifyMatch[1],
      originalUrl: cleanUrl,
    };
  }

  // 2. Apple Music
  // Matches https://music.apple.com/us/playlist/todays-hits/pl.f4d1010b19354be5bf804e3895e63d37 or /pl.f4d1010b...
  const appleMatch = cleanUrl.match(/(?:music\.apple\.com\/[a-z]{2}\/playlist\/[^\/]+\/|playlist\/)(pl\.[a-zA-Z0-9]+)/i);
  if (appleMatch) {
    return {
      platform: 'apple',
      playlistId: appleMatch[1],
      originalUrl: cleanUrl,
    };
  }

  // 3. Tidal
  // Matches https://tidal.com/browse/playlist/7c569109-847e-4091-bf0d-773a98fb3d37 or tidal.com/playlist/...
  const tidalMatch = cleanUrl.match(/(?:tidal\.com\/(?:browse\/)?playlist\/)([a-f0-9\-]+)/i);
  if (tidalMatch) {
    return {
      platform: 'tidal',
      playlistId: tidalMatch[1],
      originalUrl: cleanUrl,
    };
  }

  // 4. YouTube / YouTube Music
  // Matches https://music.youtube.com/playlist?list=PL... or https://youtube.com/playlist?list=PL...
  const youtubePlaylistMatch = cleanUrl.match(/(?:music\.youtube\.com|youtube\.com)\/playlist\?list=([a-zA-Z0-9_\-]+)/i);
  if (youtubePlaylistMatch) {
    return {
      platform: 'youtube',
      playlistId: youtubePlaylistMatch[1],
      originalUrl: cleanUrl,
    };
  }

  // Single YouTube / YouTube Music video or song share URL (watch?v=... or youtu.be/...)
  const youtubeVideoMatch = cleanUrl.match(/(?:music\.youtube\.com\/watch\?v=|youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_\-]{11})/i);
  if (youtubeVideoMatch) {
    return {
      platform: 'youtube',
      playlistId: youtubeVideoMatch[1],
      originalUrl: cleanUrl,
    };
  }

  return null;
}
